export default __webpack_public_path__ + "static/media/Graph.151a9014.svg";